import { render, staticRenderFns } from "./newAddition.vue?vue&type=template&id=fb725cf0&scoped=true"
import script from "./newAddition.vue?vue&type=script&lang=js"
export * from "./newAddition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb725cf0",
  null
  
)

export default component.exports